import { Component, Prop, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";
import { debounce } from 'lodash';
import { CartMain } from "../Cart/CartMain";

@Component
export class SideCart extends ThemeComponent {
    @Prop() drawerOpen!: string;
    @Ref() close!: HTMLDivElement;
    @Ref() header!: HTMLDivElement;
    @Ref() body!: HTMLDivElement;
    @Ref() bottom!: HTMLDivElement;
    @Ref() outter!: HTMLDivElement;

    private cartMain:CartMain = document.body.querySelector('cart-main') as CartMain;
    private _onOpenChange = new SimpleEvent<string>();
    public get onOpenChange() {
        return this._onOpenChange.asEvent();
    }

    /**
     * Initialise.
     */
    init() {
        this.eventListeners();
        this.$subscribe(this.cartMain.onCartItemCountChange, debounce((value) => {
            this.handleBodyHeight();
        }, 300));
    }

    /**
     * Event Listeners
     */
    eventListeners() {
        this.closeCart();
        this.closeEvent();

        window.addEventListener('resize',
            debounce(() => {
                this.handleBodyHeight();
            }, 300)
        );
    }

    /**
     * Open Side Cart.
     */
    openCart() {
        if (this.drawerOpen == 'true') {
            this.classList.add('is-active');
            document.body.classList.add('drawer-open');
            document.documentElement.classList.add('drawer-open');
            this.handleBodyHeight();
            this._onOpenChange.dispatch('');
            return;
        }

        window.location.href ='/cart';
    }

    /**
     * Close Side Cart.
     */
    closeCart() {
        document.addEventListener('cartClosed', ()=> {
            this.classList.remove('is-active');
            document.body.classList.remove('drawer-open');
            document.documentElement.classList.remove('drawer-open');
        });
    }

    /**
     * Cart Close click event.
     * @returns
     */
    closeEvent() {
        this.$listen(this.close, 'click', (event) => {
            event.preventDefault();
            document.dispatchEvent(new Event('cartClosed'));
        });
    }

    /**
     * Handle body height.
     */
    handleBodyHeight() {
        const headerHeight = this.header.offsetHeight;
        const bottonHeight = this.bottom.offsetHeight;
        const subtract = headerHeight + bottonHeight;

        this.body.style.maxHeight = `${window.innerHeight - subtract}px`;
    }
}
